// src/rds_ui/components/common/PriorityBadge.jsx
// Thin wrapper — real implementation in shared/ui/StatusBadge.jsx
// (map: "priority", see shared/ui/statusMaps.js's `priorityMap`).
import StatusBadge from "../../../shared/ui/StatusBadge";

export default function PriorityBadge({ priority }) {
  if (!priority) return null;
  return <StatusBadge map="priority" status={priority.toLowerCase()} className="uppercase" size="sm" />;
}
